import { IDemo, EventReplayIds } from 'types'
import { getSharedAsset } from '../utils'
import track from 'assets/captions/public-safety-replay-keynote.en.vtt'

const poster = getSharedAsset('public-safety-replay-keynote.png', 'eventReplay', 'posters')
const video = getSharedAsset('public-safety-replay-keynote.mp4', 'eventReplay', 'videos')
const nextDemoThumbnail = getSharedAsset('public-safety-replay-panel.png', 'eventReplay', 'thumbnails')

export const keynote: IDemo = {
  id: EventReplayIds.keynote,
  poster,
  video,
  tracks: [
    {
      kind: 'captions',
      src: track,
      srcLang: 'en',
      label: 'EN',
      default: false
    }
  ],
  end: {
    header: 'Learn from our experts.',
    body:
      'Verizon’s Tami Erwin, Jennifer Chronis, Patty Roze and Mike Haberman discuss Verizon’s commitment to Public Safety, define the different iterations of 5G and explain why it matters to Public Safety agencies.',
    nextDemoId: EventReplayIds.panelDiscussion,
    nextDemoText: 'How Verizon Frontline and 5G can transform Public Safety for communities',
    nextDemoThumbnail,
    previousDemoId: EventReplayIds.fullShow
  }
}
